import ko from 'knockout';
import _ from 'lodash';
import templateMarkup from 'raw-loader!./share-dashboard-modal.html';
import '../../app/bindings/ko-bindinghandler-tokenfield';
import PreferenceService from "../../services/preference.service";
import Selectr from 'mobius1-selectr/src/selectr';
import DashboardService from '../../modules/assurance/services/dashboard.service';

function ShareDashboard(params) {
  let self = this;

  if (!_.has(params, 'signals.onShow') || !_.has(params, 'signals.onSave')) {
    throw new Error('ShareDashboard:: Missing required signals: show, save');
  }
  self.signals = params.signals;
  self.signals.onShow.add(_.bind(self.show, self));
  self.signals.onSave.add(_.bind(self.save, self));

  self.updateError = ko.observable();
  self.hasUpdateError = ko.pureComputed(function () {
    return !_.isEmpty(self.updateError());
  });

  self.fromUserSelctr = new Selectr('#fromUserSelector', {
    defaultSelected: false,
    placeholder: 'Select a User...'
  } );

  let appViewData = [
    {
      text: "CPM Analytics&reg;",
      children: [
        {
          value: "historical2/historical2dashboard",
          text: "My Dashboards"
        },
        {
          value: "historical2/historical2adoption",
          text: "Adoption"
        },
        {
          value: "historical2/historical2issues",
          text: "Issues"
        },
        {
          value: "historical2/historical2capacity",
          text: "Capacity"
        },
        {
          value: "historical2/historical2roomboard",
          text: "Workspaces"
        }
      ]
    },
    {
      text: "CPM Monitoring&reg;",
      children: [
        {
          value: "assurance/dashboard",
          text: "My Dashboards"
        }
      ]
    },
    {
      text: "Workspace Insights",
      children: [
        {
          value: "rooms/historical2roomboard",
          text: "My Dashboards"
        }
      ]
    }
  ];


  self.fromAppSelctr = new Selectr('#fromAppSelector', {
    allowDeselect: true,
    clearable: true,
    defaultSelected: false,
    placeholder: 'Select an App and View...',
    data: appViewData
  } );

  self.tabsListSelctr = new Selectr('#dashboardSelector', {
    defaultSelected: false,
    placeholder: 'Select Dashboards...'
  } );

  self.toUsersSelctr = new Selectr('#toUsersSelector', {
    defaultSelected: false,
    placeholder: 'Select a User...'
  } );

  self.fromUserSelctr.on('selectr.select', function(option) {
    self.fromAppSelctr.clear();
    self.fromAppSelctr.reset(); // technically I don't need to do this, but it make loading easier
    self.updateError('');
  });

  let loadUserTabs = function(option) {
    let appView = self.fromAppSelctr.getValue();
    self.tabsListSelctr.clear();
    self.tabsListSelctr.removeAll();
    self.updateError('');
    if (appView) {
      let appViewArray = appView.split('/');
      let userId = self.fromUserSelctr.getValue();
      if (userId) {
        PreferenceService.getTabs(appViewArray[0], appViewArray[1], userId).then(tabList => {
          _.forEach(tabList, tab => {
            self.tabsListSelctr.add({value: tab.id, text: tab.name});
          });
        });
      }
    }
  };
  self.fromAppSelctr.on('selectr.select', loadUserTabs);
  self.fromAppSelctr.on('selectr.deselect', loadUserTabs);

  self.tabsListSelctr.on('selectr.change', function(option) {
    self.updateError('');
  });

  self.toUsersSelctr.on('selectr.change', function(option) {
    self.updateError('');
  });


  self.saveCallback = null;

}

ShareDashboard.prototype.show = function (model) {
  var self = this;

  if (!_.has(model, 'appId')) {
    throw new Error('ShareDashboard needs a model with an appId.');
  }
  if (!_.has(model, 'viewId')) {
    throw new Error('ShareDashboard needs a model with an viewId.');
  }

// not sure if I need any of these to pre-populate the advanced dialog entries
  // self.appId = model.appId;
  // self.viewId = model.viewId;
  // self.currentBoard = model.currentBoard;
  // self.currentUserId = model.currentUserId;

  self.saveCallback = model.saveCallback;
  self.updateError(null);

  // not super efficient resetting and reloading all data, but works for now
  self.fromUserSelctr.clear();
  self.fromUserSelctr.removeAll();

  self.fromAppSelctr.clear();
  self.fromAppSelctr.reset();

  self.tabsListSelctr.clear();
  self.tabsListSelctr.removeAll();
  self.toUsersSelctr.clear();
  self.toUsersSelctr.removeAll();


  DashboardService.fetchUsersForCurrentOrgTemp().then(users => {
    _.forEach(users, user => {
      if (!user.deleted) {
        self.fromUserSelctr.add({value: user.id, text: user.name});
        self.toUsersSelctr.add({value: user.id, text: user.name});
      }
    })
  });

};

ShareDashboard.prototype.save = function () {
  var self = this;

  let fromAppId = self.fromAppSelctr.getValue();

  let fromUserId = self.fromUserSelctr.getValue();
  let toUserIds = self.toUsersSelctr.getValue().map(Number);
  let fromBoards = self.tabsListSelctr.getValue();

  if (fromAppId && fromUserId && toUserIds && toUserIds.length && fromBoards && fromBoards.length) {
    let fromAppViewArray = fromAppId.split('/');

    var from = { user: Number(fromUserId),     appId: fromAppViewArray[0], viewId: fromAppViewArray[1]  , boards: fromBoards };
    var to   = { users: toUserIds, appId: fromAppViewArray[0], viewId: fromAppViewArray[1] };
    console.log("Copy "+ JSON.stringify(from) + " to "+ JSON.stringify(to));

    try {
      PreferenceService.addTabs(from, to);
      self.updateError('');
    } catch (e) {
      console.error(e);
      self.updateError('There was an error sharing the dashboards.');
    }
  } else {
    self.updateError('Please fill in all fields.')
  }
  if (!self.hasUpdateError()) {
    self.signals.closeModal.dispatch();
    if (self.saveCallback) self.saveCallback();
  }
};

ShareDashboard.prototype.dispose = function () {
  var self = this;
  self.signals.onShow.dispose();
  self.signals.onSave.dispose();
};

export default {viewModel: ShareDashboard, template: templateMarkup};
